import ndsTokens from 'nicollet-tokens';
import styled from 'styled-components';
import { ndsBoxSizing, ndsFontReset, ndsFormStyles } from '@nicollet/common';

const ErrorMessage = styled.span`
  background-color: ${({
  errorBackground
}) => errorBackground !== null && errorBackground !== void 0 ? errorBackground : 'transparent'};
  ${ndsBoxSizing}
  ${ndsFontReset({
  color: ndsFormStyles.colors.alert.warning.text,
  display: 'block',
  fontSize: ndsTokens.font.size.text.small,
  paddingTop: ndsTokens.space.generic.x1
})};
`;

export { ErrorMessage };
